module.exports = __webpack_public_path__ + "static/Roboto-Bold-ee7b96fa85d8fdb8c126409326ac2d2b.ttf";